export const darkenColor = (color: string, percent: number): string => {
    // Convert the color to HSL
    const hsl = hexToHsl(color);

    // Reduce the lightness by the specified percentage
    hsl[2] = Math.max(0, hsl[2] - percent / 100);

    // Convert back to hex
    return hslToHex(hsl);
};

// Convert HEX to HSL
const hexToHsl = (hex: string): [number, number, number] => {
    // Convert hex to RGB first
    let r = 0,
        g = 0,
        b = 0;
    if (hex.length === 4) {
        r = parseInt(hex[1] + hex[1], 16);
        g = parseInt(hex[2] + hex[2], 16);
        b = parseInt(hex[3] + hex[3], 16);
    } else if (hex.length === 7) {
        r = parseInt(hex[1] + hex[2], 16);
        g = parseInt(hex[3] + hex[4], 16);
        b = parseInt(hex[5] + hex[6], 16);
    }

    // Then to HSL
    r /= 255;
    g /= 255;
    b /= 255;
    const max = Math.max(r, g, b),
        min = Math.min(r, g, b);
    let h = 0,
        s = 0;

    const l = (max + min) / 2;

    if (max !== min) {
        const d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch (max) {
            case r:
                h = (g - b) / d + (g < b ? 6 : 0);
                break;
            case g:
                h = (b - r) / d + 2;
                break;
            case b:
                h = (r - g) / d + 4;
                break;
            default:
                break;
        }
        h /= 6;
    }
    return [Math.round(h * 360), Math.round(s * 100), Math.round(l * 100)];
};

// Convert HSL to HEX
const hslToHex = ([h, s, l]: [number, number, number]): string => {
    l /= 100;
    const a = (s * Math.min(l, 1 - l)) / 100;
    const f = (n: number) => {
        const k = (n + h / 30) % 12;
        const color = l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
        return Math.round(255 * color)
            .toString(16)
            .padStart(2, '0'); // convert to Hex and prefix "0" if needed
    };
    return `#${f(0)}${f(8)}${f(4)}`;
};

export const rgbToHex = (rgb: string) => {
    const rgbValues = rgb.match(/\d+/g);
    const r = parseInt(rgbValues![0]).toString(16).padStart(2, '0');
    const g = parseInt(rgbValues![1]).toString(16).padStart(2, '0');
    const b = parseInt(rgbValues![2]).toString(16).padStart(2, '0');
    return `#${r}${g}${b}`;
};

export const hexToRgb = (hex: string) => {
    hex = hex.replace(/^#/, '');

    const bigint = parseInt(hex, 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;

    return [r, g, b];
};
export const getContrastingColor = (hex: string) => {
    const rgbValues = hexToRgb(hex);
    const r = rgbValues[0];
    const g = rgbValues[1];
    const b = rgbValues[2];

    const brightness = (r * 299 + g * 587 + b * 114) / 1000;

    return brightness > 128 ? 'black' : 'white';
};
